import styled from 'styled-components';
import { layoutSizes, fontSizes, colours } from "../../../../constants/css";
export var H2Styled = styled.h2.withConfig({
  displayName: "style__H2Styled",
  componentId: "sc-svk5i5-0"
})(["font-size:1.375rem;font-weight:500;margin:0;span{font-size:2.25rem;color:", ";font-weight:normal;line-height:0.67;}@media only screen and (min-width:", "){font-size:", ";font-weight:500;line-height:1.25;span{font-size:2.375rem;font-weight:normal;}}"], colours.qantasRed, layoutSizes.desktopWidth, fontSizes.xxl);